import React from 'react'
import CCCongratulationsPage from './Congratulations'

const CongratulationLimitIncrease = () => {
  return (
    <CCCongratulationsPage
      title='Thank you for accepting the offer!'
      subtitle='Excellent choice!'
      message='Your credit card limit increase will be processed within one business day. If you have any questions, please feel free to contact us via our secure online message center.'
    />
  )
}

export default CongratulationLimitIncrease
